import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-categories-quick-actions',
  template: require('./categories-quick-actions.component.html')
})
export class CategoriesQuickActionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/categories-quick-actions/categories-quick-actions.component.ts